import { isEmpty, map } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { CmsInsuranceTypeContent, CrossSellType } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';

type Props = {
  cmsSectionContent?: CmsInsuranceTypeContent['crossSell'];
  insuranceType?: string | null;
};

const mapCrossSellContent = ({ cmsSectionContent, insuranceType }: Props) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const formattedContent = map((contentItems: CrossSellType) => {
    const { descriptionRaw, name, rootUrl, tileImage } = contentItems;

    const description = portableTextToPlain(descriptionRaw);
    const image = tileImage ? getImageAttributes({ imageObject: tileImage, width: 240 }) : null;

    const sortedContent = {
      cta: {
        title: 'Find out more',
        to: rootUrl,
      },
      description,
      image,
      name: `${name} insurance`,
    };

    return sortedContent;
  }, cmsSectionContent);

  return {
    content: formattedContent,
    insuranceType,
    type: CONTENT_SECTIONS.CROSS_SELL,
  };
};

export default mapCrossSellContent;
